import {
  collapse,
  expandCollapse,
  handleClickOutside,
} from '~/js/utils/expand-collapse';

const dropdownToggle = document.querySelector('.ar-download__toggle');
const dropdownList = document.querySelector('.ar-download__list');

(() => {
  if (!dropdownToggle) return;

  // Add event listener for expanding/collapsing AR download dropdown.
  dropdownToggle.addEventListener('click', () => {
    expandCollapse(dropdownList, dropdownToggle);
  });

  // Add click outside handler on desktop.
  handleClickOutside(dropdownList, dropdownToggle);

  // Close dropdown on Esc.
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      collapse(dropdownList, dropdownToggle);
    }
  });
})();
